import { ICustomizerState } from "./customizer/customizerReducer";
import { IMessagesState } from "./messages/messages.types";
import { initialMessagesState } from "./messages/messagesState";
import { IStudentState } from "./student/student.types";
// import { IAutomobilePolicyRiskLocationState, defaultAutomobilePolicyRiskLocationState } from "./automobilePolicyRiskLocation/automobilePolicyRiskLocation.types";
import { defaultCommonState, ICommonState } from "./common/common.types";

import { IUsersState } from "./UserProfileList/userProfile.types";
import { initialUserProfileState } from "./UserProfileList/userprofileState";

import {
  IAcitivtyState,
  initialAcitvityState,
} from "./activity/activity.types";
import { ILeadsState, initialLeadState } from "./leads/leads.types";
import { defaultOpportunityState } from "./opportunites/deafaultState";
import { IOpportunityState } from "./opportunites/opportunites.types";
import { IGenAiState } from "./genAi/genAi.types";
import { defaultGenAiState } from "./genAi/deafaultState";
import {
  initialSecurityState,
  ISecurityState,
} from "./security/security.types";
import { defaultStudentState } from "./student/studentState";
import {
  initialTemplateState,
  ITemplateState,
} from "./templates/templates.types";

import {
  defaultUserDocument,
  defaultUserDocumentState,
} from "./userDocument/userDocument.state";
import {
  IUserDocument,
  IUserDocumentState,
} from "./userDocument/userDocument.types";
import { IUserBranchState } from "./userBranch/userBranch.types";
import { defaultUserBranchState } from "./userBranch/userBranch.state";
import {
  IEnvConfigState,
  initialEnvConfigState,
} from "./envConfig/envConfig.types";
import {
  ICompanyInformationState,
  initialCompanyInformation,
} from "./CompanyInformation/companyInformation.types";
import { IBookingState, initialBookingState } from "./booking/booking.types";
import {
  ICategoryState,
  initialCategoryState,
} from "./category/category.types";
import {
  ICategoryTypeState,
  initialCategoryTypeState,
} from "./categoryType/categoryType.types";

import {
  IMarketCampaignState,
  initialMarketCampaignState,
} from "./marketCampaign/marketCampaign.types";
import { IGoogleReviewState } from "./Review/review.types";
import { defaultGoogleReviewState } from "./Review/review.state";
import { ICompanyOutletState } from "./companyOutlet/companyOutlet.types";
import { initialCompanyOutletState } from "./companyOutlet/defaultState";
import { IPaymentDetailsState } from "./paymentDetails/paymentDetails.types";
import { initialPaymentDetailsState } from "./paymentDetails/defaultState";
import { IMetaDataState } from "./metaData/metaData.types";
import { initialMetaDataState } from "./metaData/defaultState";
import { IBankDetailsState } from "./bankDetails/bankDetails.types";
import { initialBankDetailsState } from "./bankDetails/defaultState";
import { IContactsState, initialContactState } from "./contacts/contacts.types";

import {
  defaultCompanyOutletAttachmentState,
  ICompanyOutletAttachmentState,
} from "./customerVendorAttachment";
import {
  ICompanyOutletAddressState,
  initialCompanyOutletAddressState,
} from "./customerDeliveryAddress";
import { ISubscriptionPlanState } from "./subscription/subscription.types";
import { initialSubscriptionPlanState } from "./subscription/defaultState";

import { IOrgEnvConfigState } from "./orgEnvConfig/orgEnvConfig.types";
import { initialOrgEnvConfigState } from "./orgEnvConfig/orgEnvConfig.types";

import {
  IAutomationState,
  initialAutomationState,
} from "./automation/automation.types";
import { IStatusState, initialStatusState } from "./status/status.types";
import { initialFoodState } from "./food/defaultState";
import { IFoodState } from "./food/food.types";
import { IChatbotState, initialChatbotState } from "./chatbot/chatbot.types";
import { ISupportState } from "./support/support.types";
import { initialSupportState } from "./support/defaultState";

import { IMasterFormsState } from "./masterForm/masterForms.types";

import { initialMasterFormsState } from "./masterForm/defaultState";
import { IServiceState } from "./service/service.types";
import { initialServiceState } from "./service/defaultState";
import { IEventState } from "./event/event.types";
import { initialEventState } from "./event/defaultState";
import { IFormsState } from "./dynamicFormsV2/forms.types";
import { initialFormsState } from "./dynamicFormsV2/defaultState";
import { IWhatsAppTemplateState } from "./whatsappTemplate/whatsappTemplate.types";
import { initialWhatsAppTemplateState } from "./whatsappTemplate/defaultState";
import { initialActionItemState } from "./actionItems/actionItem.state";
import { IActionItemsState } from "./actionItems";
import { IQuickReplyTemplateState } from "./quickReplyTemplates/quickReplyTemplate.types";
import { initialQuickReplyTemplateState } from "./quickReplyTemplates/defaultState";
import { initialRestrictedWords } from "./restrictedWords/defaultState";
import { IRestrictedWords } from "./restrictedWords/restrictedWords.types";
import { initialUpsellLeadsState } from "./upsellLead/defaultState";
import { IUpsellLeadsState } from "./upsellLead/upsellLeads.types";
import { IVariantsState } from "./variants/variants.types";
import { initialVariantsState } from "./variants/defaultState";

export interface IDropdownListType {
  key: string;
  text: string;
  value: string;
}

export interface IStoreState {
  customizerReducer: ICustomizerState;
  student: IStudentState;
  message: IMessagesState;
  acitivty: IAcitivtyState;
  security: ISecurityState;

  userprofile: IUsersState;
  common: ICommonState;
  templates: ITemplateState;

  companyInformation: ICompanyInformationState;

  opportunites: IOpportunityState;
  leads: ILeadsState;
  genAi: IGenAiState;

  userDocument: IUserDocumentState;
  userBranch: IUserBranchState;
  envConfig: IEnvConfigState;
  booking: IBookingState;

  category: ICategoryState;

  categoryType: ICategoryTypeState;
  food: IFoodState;
  marketCampaign: IMarketCampaignState;
  review: IGoogleReviewState;
  companyOutlet: ICompanyOutletState;
  bankDetails: IBankDetailsState;
  contacts: IContactsState;
  companyOutletAddress: ICompanyOutletAddressState;
  companyOutletAttachment: ICompanyOutletAttachmentState;
  payment_details: IPaymentDetailsState;
  metaData: IMetaDataState;
  subscriptionPlan: ISubscriptionPlanState;
  orgEnvConfig: IOrgEnvConfigState;
  automation: IAutomationState;
  status: IStatusState;
  // metaTemplate: IMetaTemplateState;
  whatsappTemplate: IWhatsAppTemplateState;
  quickReplyTemplate: IQuickReplyTemplateState;
  chatbot: IChatbotState;
  support: ISupportState;

  forms: IFormsState;
  masterForms: IMasterFormsState;
  service: IServiceState;
  event: IEventState;
  actionItems: IActionItemsState;
  restrictedWords: IRestrictedWords;
  upsellLeads: IUpsellLeadsState;
  variants: IVariantsState;

  //HR
}

export const initialStoreState: IStoreState = {
  //if you want to change the theme of framework, first go to themevariable.ts file, and set your theme there, then come in this file and simply put your theme in activveTheme
  customizerReducer: {
    activeDir: "ltr",
    activeNavbarBg: "#0b70fb", // This can be any color,
    activeSidebarBg: "#ffffff", // This can be any color
    activeMode: "light", // This can be light or dark
    activeTheme: "FEE_MANAGEMENT_THEME", // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
    SidebarWidth: 240,
    sidebarOpen: true,
  },

  student: defaultStudentState,
  message: initialMessagesState,
  templates: initialTemplateState,
  security: initialSecurityState,

  common: defaultCommonState,
  acitivty: initialAcitvityState,

  userprofile: initialUserProfileState,

  companyInformation: initialCompanyInformation,

  opportunites: defaultOpportunityState,
  leads: initialLeadState,
  genAi: defaultGenAiState,

  userDocument: defaultUserDocumentState,
  userBranch: defaultUserBranchState,

  envConfig: initialEnvConfigState,
  booking: initialBookingState,

  category: initialCategoryState,

  categoryType: initialCategoryTypeState,
  food: initialFoodState,
  marketCampaign: initialMarketCampaignState,
  review: defaultGoogleReviewState,
  companyOutlet: initialCompanyOutletState,
  bankDetails: initialBankDetailsState,
  contacts: initialContactState,
  companyOutletAddress: initialCompanyOutletAddressState,
  companyOutletAttachment: defaultCompanyOutletAttachmentState,

  payment_details: initialPaymentDetailsState,
  metaData: initialMetaDataState,
  subscriptionPlan: initialSubscriptionPlanState,
  orgEnvConfig: initialOrgEnvConfigState,
  automation: initialAutomationState,
  status: initialStatusState,
  // metaTemplate: initialMetaTemplateState,
  whatsappTemplate: initialWhatsAppTemplateState,
  quickReplyTemplate: initialQuickReplyTemplateState,
  chatbot: initialChatbotState,
  support: initialSupportState,
  forms: initialFormsState,
  masterForms: initialMasterFormsState,
  service: initialServiceState,
  event: initialEventState,
  actionItems: initialActionItemState,
  restrictedWords: initialRestrictedWords,
  upsellLeads: initialUpsellLeadsState,
  variants: initialVariantsState,
};
